import { render, staticRenderFns } from "./TeamDashboardV2.vue?vue&type=template&id=e4bf5a32&scoped=true&"
import script from "./TeamDashboardV2.vue?vue&type=script&lang=ts&"
export * from "./TeamDashboardV2.vue?vue&type=script&lang=ts&"
import style0 from "./TeamDashboardV2.vue?vue&type=style&index=0&id=e4bf5a32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4bf5a32",
  null
  
)

export default component.exports